export const summaryRows: string[] = [
  'Volume 1 — Hydrogen Energy Fundamentals & Technical Principles',
  'Volume 2 — Hydrogen Production & Electrolysis Technologies',
  'Volume 3 — Hydrogen Storage, Transportation & Infrastructure',
  'Volume 4 — Fuel Cell Technologies & Power Generation Systems',
  'Volume 5 — Hydrogen Systems Integration & Industrial Applications',
  'Volume 6 — Hydrogen Safety, System Reliability & Future Technologies',
  'Bonus 1 — Technical Dictionary & Terminology',
  'Bonus 2 — Hydrogen vs. Battery Energy Storage Comparison',
  'Bonus 3 — 16 Myths & Technical Realities Explained',
  'Bonus 4 — Project Economics & Industry Terminology',
  'Bonus 5 — 12 Industry Scenarios & Technology Perspectives',
  '7-day money-back guarantee',
  'Instant access',
];
